/**
 * Define all of your application routes here
 * for more information on routes, see the
 * official documentation https://router.vuejs.org/en/
 */
export default [
  {
      path: '/about-us',
      name: 'About Us',
      view: 'AboutUs'
  },
  {
      path: '/app-development',
      name: 'App Development',
      view: 'AppDevelopment'
  },
  {
      path: '/portfolio',
      view: 'Portfolio'
  },
  {
       path: '/landing',
       name: 'Landing',
       view: 'Landing'
   },
  {
      path: '/contact-us',
      name: 'Contact Us',
      view: 'ContactUs'
  },
  {
      path: '/web-development',
      name: 'Web Development',
      view: 'WebDevelopment'
  },
  {
      path: '/showcase',
      name: 'Showcase',
      view: 'Showcase'
  },
//   {
//       path: '/newsletter',
//       name: 'Newsletter',
//       view: 'Newsletter'
//   },
//   {
//     path: "/maintenance",
//     name: "Maintenance",
//     view: "Maintenance"
//   }
];
